// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3_4bH","tab":"ProcedureTabs_tab__2nf9S"};